import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ChunkRecoveryService } from '@shared/services/chunk-recovery.service';
import { UpdatesService } from '@shared/services/updates.service';
import { signupEnvironment } from '@signup/environment/environment.signup';
import { EnvironmentsService } from '@signup/shared/services/environments.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    private readonly _environments: EnvironmentsService,
    private readonly _translate: TranslateService,
    _updates: UpdatesService, // eager-instantiate so SW poll/visibility wiring runs
    _chunkRecovery: ChunkRecoveryService // eager-instantiate so Router NavigationError subscription runs
  ) {
    const lng = 'en';
    this._translate.setDefaultLang(lng);
    this._translate.use(lng);

    // (window as any)['Chargebee'].init({
    //   site: 'vitay-test',
    //   publishableKey: signupEnvironment.CHARGEBEE.PUBLISHABLE_KEY
    // });

    this._environments.setScripts();
  }

  ngOnInit(): void {}
}
